/** Class representing a simple in-memory cache */
export class DataCache {
  /**
   * Create an in-memory cache instance
   * Reference: https://www.mojotech.com/blog/node-js-memory-cache/
   * @param {*} fetchFunction - The callback function to fetch data
   * @param {number} minutesToLive - The cache lifetime, in minutes
   */
  constructor(fetchFunction, minutesToLive = 10) {
    this.millisecondsToLive = minutesToLive * 60 * 1000;
    this.fetchFunction = fetchFunction;
    this.cache = null;
    this.getData = this.getData.bind(this);
    this.resetCache = this.resetCache.bind(this);
    this.isCacheExpired = this.isCacheExpired.bind(this);
    this.fetchDate = new Date(0);
  }

  isCacheExpired() {
    return this.fetchDate.getTime() + this.millisecondsToLive < Date.now();
  }

  getData() {
    if (!this.cache || this.isCacheExpired()) {
      this.cache = this.fetchFunction();
      this.fetchDate = new Date();
      return this.cache;
    } else {
      return this.cache;
    }
  }

  resetCache() {
    this.fetchDate = new Date(0);
  }
}
